module.exports = __webpack_public_path__ + "img/hp-banner-1.fc88a692.jpg";